import { ToolPageShell } from '@/shared/seo'
import { PomenyatPoryadokStranicPdfForm } from './PomenyatPoryadokStranicPdfForm'

export function PomenyatPoryadokStranicPdfPage() {
  return (
    <ToolPageShell utilityKey="reorder-pdf-pages">
      <PomenyatPoryadokStranicPdfForm />
    </ToolPageShell>
  )
}
